/* tslint:disable */
 
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum AppCrehanaFaqEnum {
  ACADEMIES = "ACADEMIES",
  B2B_CLASSROOM = "B2B_CLASSROOM",
  B2B_DETAIL = "B2B_DETAIL",
  B2B_LANDING = "B2B_LANDING",
  COURSE_DETAIL = "COURSE_DETAIL",
  DEGREE_DETAIL = "DEGREE_DETAIL",
  MARATHON_LANDING = "MARATHON_LANDING",
  MEMBERSHIP_DETAIL = "MEMBERSHIP_DETAIL",
}

export enum CourseVideoTrailerSourceVideoSourceType {
  HLSV3 = "HLSV3",
  HLSV4 = "HLSV4",
  MP3 = "MP3",
  MP4 = "MP4",
  NONE = "NONE",
}

export enum OrganizationDepartmentEnum {
  ADMIN = "ADMIN",
  FINANCE = "FINANCE",
  HUMAN_RESOURCES = "HUMAN_RESOURCES",
  INNOVATION = "INNOVATION",
  IT = "IT",
  MARKETING = "MARKETING",
  OPERATIONS = "OPERATIONS",
  OTHER = "OTHER",
  SALES = "SALES",
}

export enum OrganizationRoleEnum {
  ANALYST = "ANALYST",
  CEO = "CEO",
  C_LEVEL = "C_LEVEL",
  DIRECTOR = "DIRECTOR",
  ESTUDIANTE = "ESTUDIANTE",
  EXECUTIVE = "EXECUTIVE",
  FOUNDER = "FOUNDER",
  FREELANCE = "FREELANCE",
  GENERALIST_COORDINATOR = "GENERALIST_COORDINATOR",
  INTERN = "INTERN",
  MANAGEMENT = "MANAGEMENT",
  OTHER = "OTHER",
  VP = "VP",
}

export enum OrganizationSizeEnum {
  SIZE_MAX_1000 = "SIZE_MAX_1000",
  SIZE_MAX_250 = "SIZE_MAX_250",
  SIZE_MORE_THAN_1000 = "SIZE_MORE_THAN_1000",
  SIZE_MORE_THAN_5000 = "SIZE_MORE_THAN_5000",
}

export enum OriginLeadSectionEnum {
  B2B_FREE_TRIAL_LANDING = "B2B_FREE_TRIAL_LANDING",
  BLOG = "BLOG",
  BUSINESS_LANDING = "BUSINESS_LANDING",
  COURSE_DETAIL_LANDING = "COURSE_DETAIL_LANDING",
  COURSE_FREE_LANDING = "COURSE_FREE_LANDING",
  HOMEPAGE = "HOMEPAGE",
  OTHER = "OTHER",
}

export enum OriginRequestEnum {
  B2C2B = "B2C2B",
  DOWNLOADABLE_RESOURCE = "DOWNLOADABLE_RESOURCE",
  HIGHER = "HIGHER",
  PARTNER = "PARTNER",
  REGISTER = "REGISTER",
  SUMMIT = "SUMMIT",
}

//==============================================================
// END Enums and Input Objects
//==============================================================
